module.exports = __webpack_public_path__ + "img/fm_workflow_2.034906fc.png";